import { useCRUDModalList } from '@/shared/hooks/useCRUDModalList';
import { useServiceStatus } from '@/contexts/service-status';
import { inspectionReasonService } from '@/services/inspectionReason.service';
import type { InspectionReason, CreateInspectionReasonRequest, UpdateInspectionReasonRequest } from '@/services/types/user.types';

const inspectionReasonServiceAdapter = {
  getAll: () => inspectionReasonService.getAll(),
  create: (data: CreateInspectionReasonRequest) => inspectionReasonService.create(data).then(() => ({} as InspectionReason)),
  update: (id: string, data: UpdateInspectionReasonRequest) => inspectionReasonService.update(id, data).then(() => ({} as InspectionReason)),
  delete: (id: string) => inspectionReasonService.delete(id),
};

export function useInspectionReasonList() {
  const { isServiceOnline } = useServiceStatus();
  const isUserServiceOnline = isServiceOnline('user');

  const {
    items: inspectionReasons,
    loading,
    isModalOpen,
    editingItem,
    submitting,
    form,
    handleNew,
    handleEdit,
    handleDelete,
    handleModalCancel,
    handleModalSubmit,
  } = useCRUDModalList<InspectionReason, CreateInspectionReasonRequest, UpdateInspectionReasonRequest>({
    service: inspectionReasonServiceAdapter,
    entityName: 'motivo de inspeção',
    enabled: isUserServiceOnline,
    mapToFormValues: (item) => ({
      name: item.name,
      description: item.description,
      isActive: item.isActive,
    }),
    mapFromFormValues: (values, isEditing) => {
      if (isEditing) {
        return {
          name: values.name as string,
          description: values.description as string,
          isActive: (values.isActive as boolean) ?? true,
        };
      }
      return {
        name: values.name as string,
        description: values.description as string,
      };
    },
    messages: {
      loadError: 'Erro ao carregar motivos de inspeção',
      createSuccess: 'Motivo de inspeção criado com sucesso!',
      updateSuccess: 'Motivo de inspeção atualizado com sucesso!',
      deleteSuccess: 'Motivo de inspeção excluído com sucesso!',
      deleteError: 'Erro ao excluir motivo de inspeção',
      saveError: 'Erro ao salvar motivo de inspeção',
      deleteConfirmContent: 'Tem certeza que deseja remover este motivo de inspeção? Esta ação não pode ser desfeita.',
    },
  });

  return {
    inspectionReasons,
    loading,
    isModalOpen,
    editingItem,
    submitting,
    form,
    handleNew,
    handleEdit,
    handleDelete,
    handleModalCancel,
    handleModalSubmit,
  };
}
